import { SettingsManager } from "@viamap/viamap2-common";

// Import sources
import Denmark from "src/mapStyles/sources/Denmark.json";
import World from "src/mapStyles/sources/World.json"

// Import styles
import Balder from "src/mapStyles/styles/Balder.json";
import Campaya from "src/mapStyles/styles/Campaya.json";
import Danbolig from "src/mapStyles/styles/Danbolig.json";
import GenericDefaultStyle from "src/mapStyles/styles/GenericDefaultStyle.json";
import MitSkaermkort from "src/mapStyles/styles/MitSkaermkort.json";
import Kjeldskov from "src/mapStyles/styles/Kjeldskov.json";
import Klokantech from "src/mapStyles/styles/Klokantech.json";
import MapitV3 from "src/mapStyles/styles/MapitV3.json";
import Marselisborg from "src/mapStyles/styles/Marselisborg.json";
import ExplorerV3 from "src/mapStyles/styles/ExplorerV3.json";
import Americana from "src/mapStyles/styles/Americana.json";
import Bright from "src/mapStyles/styles/Bright.json";
import DarkMatter from "src/mapStyles/styles/DarkMatter.json";
import Outdoors from "src/mapStyles/styles/Outdoors.json";
import Positron from "src/mapStyles/styles/Positron.json";
import TBAuctions from "src/mapStyles/styles/TBAuctions.json";
import Toner from "src/mapStyles/styles/Toner.json";



export type BuiltInStyles = typeof builtInStyles[number] | "Default";
export const builtInStyles = [
   "Balder",
   "Campaya",
   "Danbolig",
   "GenericDefaultStyle",
   "MitSkaermkort",
   "Kjeldskov",
   "Klokantech",
   "MapitV3",
   "Marselisborg",
   "ExplorerV3",
   "Americana",
   "Bright",
   "DarkMatter",
   "Outdoors",
   "Positron",
   "TBAuctions",
   "Toner"
] as const

export type BuiltInVectorSources = "Denmark" | "World" | "Default";
export const builtInVectorSources = [
   "Denmark",
   "World"
] as string[]

export function getVectorSource(source?: BuiltInVectorSources | string): object | string {
   if (!(source == "World" || source == "Denmark")) {
      source = SettingsManager.getSystemSetting("vectorSource", "Denmark");
   }
   switch (source) {
      case "World":
         return structuredClone(World);
      case "Denmark":
         return structuredClone(Denmark);
      default:
         return structuredClone(Denmark); // Default to Denmark if not recognized
   }
}

export type BuiltInStyleMods = typeof builtInStyleMods[number];
export const builtInStyleMods = [
   "Ortophoto",
   "OrthophotoNoWaterMask",
   "No3D",
   "NoBuildings",
   "NoRoads",
   "NoText",
   "NoAeroways",
   "HillShadows"
] as const

export function getMapStyle(style?: BuiltInStyles | string | undefined): object {
   if (!isBuiltInStyle(style)) {
      style = SettingsManager.getSystemSetting("vectorMapStyle", "MapitV3");
   }
   switch (style) {
      case "Balder":
         return structuredClone(Balder);
      case "Campaya":
         return structuredClone(Campaya);
      case "Danbolig":
         return structuredClone(Danbolig);
      case "GenericDefaultStyle":
         return structuredClone(GenericDefaultStyle);
      case "MitSkaermkort":
         return structuredClone(MitSkaermkort);
      case "Kjeldskov":
         return structuredClone(Kjeldskov);
      case "Klokantech":
         return structuredClone(Klokantech);
      case "MapitV3":
         return structuredClone(MapitV3);
      case "Marselisborg":
         return structuredClone(Marselisborg);
      case "ExplorerV3":
         return structuredClone(ExplorerV3);
      case "Americana":
         return structuredClone(Americana);
      case "Bright":
         return structuredClone(Bright);
      case "DarkMatter":
         return structuredClone(DarkMatter);
      case "Outdoors":
         return structuredClone(Outdoors);
      case "Positron":
         return structuredClone(Positron);
      case "TBAuctions":
         return structuredClone(TBAuctions);
      case "Toner":
         return structuredClone(Toner);
      default:
         return structuredClone(MapitV3); // Default to MapitV3 if not recognized
   }
}

export function isBuiltInStyle(style?: string): style is typeof builtInStyles[number] {
   if (!style) return false
   return builtInStyles.includes(style as typeof builtInStyles[number])
}